import axios from 'axios';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { getFirstPathSegment, logEvent } from '../../../new-lib/analytics';

const useDownloadPDF = () => {
  const { locale, asPath } = useRouter();

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPDF = useCallback(async () => {
    setIsDownloading(true);

    try {
      const response = await axios.get(
        `${process.env.NEXT_PUBLIC_HOST}/assets/data/${
          locale === 'en' ? `map-sahel.pdf` : `map-sahel-ar.pdf`
        }`,
        { responseType: 'blob' }
      );
      const tempUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = tempUrl;
      link.setAttribute(
        'download',
        `${locale === 'en' ? 'Sahel Map' : 'خريطة الساحل'}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      setIsDownloading(false);

      logEvent.click(
        'map_download_pdf',
        getFirstPathSegment(asPath),
        'map'
      );
    } catch (error) {
      setIsDownloading(false);
    }
  }, [locale, asPath]);

  return { isDownloading, downloadPDF };
};

export default useDownloadPDF;
